import type { SavingSettingsDetailsCountryConfig } from './SavingSettingsDetailsConfig';

export const settingsDetails: SavingSettingsDetailsCountryConfig = {
    displayDisposableBalance: true,
    averageSavings: {
        displayAccountOwner: true,
        displayIban: true,
        displayBIC: true,
    },
    termDeposit: {
        displayAccountOwner: true,
        displayIban: true,
        displayBIC: true,
    },
    displayProductTerm: true,
    displayCreditInterestRateToDate: true,
    displayCreditInterestRatePeriod: true,
    displayDebitInterestRate: true,
    displayDebitInterestRatePeriod: true,
    displayFees: true,
};
